import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const CustomerServices = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/v1/customer`);
    return response.data;
  },

  create: async (postData) => {
    const response = await apiService.post(`/${slug}/v1/customer`, postData);
    return response.data;
  },
  confirm: async (data) => {
    const response = await apiService.post("/customer/confirmed", data);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/customer/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/v1/customer/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/${slug}/v1/customer/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default CustomerServices;
